import type { ContainerContext } from '@athena-lib/container-context.svelte';
import type { DeviceName } from '@athena-lib/device';
import { objectEntries } from '@athena-lib/object-utils';
import { breakpoints } from '@athena-lib/responsive-utils';

const screenMinWidths: Record<DeviceName, number> = {
  // We do this instead of screenMinWidths = breakpoints because the order of the keys is important,
  // and we want the min width to be 0 and not 640 for sm
  lg: breakpoints.lg,
  md: breakpoints.md,
  sm: 0,
};

export const generatePictureSources = (
  src: string,
  imageResizingUrlProvider: (imageWidth: number, imageBaseUrl: string) => string,
  containerContext: ContainerContext,
  widthOfContainer: number | undefined,
) => {
  const currentWidth = containerContext.getCurrentWidth();
  return objectEntries(screenMinWidths).map(([deviceName, minWidth]) => {
    const width = currentWidth[deviceName].pixelWidth * (widthOfContainer ?? 1);
    const srcSet = [
      `${imageResizingUrlProvider(roundWidthOrHeight(width), src)}`,
      `${imageResizingUrlProvider(roundWidthOrHeight(width * 1.5), src)} 1.5x`,
      `${imageResizingUrlProvider(roundWidthOrHeight(width * 2), src)} 2x`,
    ].join(', ');
    return {
      srcset: `${srcSet}`,
      media: `(min-width: ${minWidth}px)`,
      estimatedWidth: width,
    };
  });
};

const roundTo = 200;

// We round the size to the nearest 200 to avoid unnecessary image resizing
export const roundWidthOrHeight = (size: number) =>
  size % roundTo === 0 ? size : Math.round((size + roundTo / 2) / roundTo) * roundTo;
